import { render, staticRenderFns } from "./TypeFileXLSXIcon.vue?vue&type=template&id=1faa6438&"
import script from "./TypeFileXLSXIcon.vue?vue&type=script&lang=js&"
export * from "./TypeFileXLSXIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports